import { createSelector } from 'reselect';
const getReducer = (state) => state.entityInfo;
export const selectShowEntityInspector = createSelector(getReducer, ({ showEntityInspector }) => showEntityInspector);
